<template>
    <!-- :resizableColumns="true" -->
    <DataTable
        selectionMode="single"
        :value="tasks"
        :lazy="true"
        :paginator="true"
        :rows="10"
        dataKey="id"
        :totalRecords="totalTaskRecords"
        :loading="loading || loadingTaskList"
        @page="onPage"
        @rowSelect="rowSelected"
        responsiveLayout="scroll"
        :rowsPerPageOptions="[5, 10, 20, 50, 100]"
        paginatorTemplate="CurrentPageReport JumpToPageInput FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries :: Page No:"
    >
        <template #empty> No {{ label('Tasks').toLowerCase() }} available. </template>
        <template #loading> Loading {{ label('Tasks').toLowerCase() }}. Please wait. </template>
        <Column field="title" :header="`${label('Task').toUpperCase()} TITLE`" style="width: 8rem" />
        <Column field="description" :header="`${label('Task').toUpperCase()} DESCRIPTION`" style="width: 10rem">
            <template #body="slotProps">
                <span v-if="slotProps.data.description">
                    <span v-html="truncateText(slotProps.data.description, 30)"></span>
                </span>
                <span v-else>No Description</span>
            </template>
        </Column>
        <Column field="theme_name" header="THEME" style="width: 5rem" />
        <Column field="department_to" header="RESPONSIBLE DEPARTMENT" style="width: 9rem" />
        <Column field="task_progress" header="STATUS" style="width: 5rem">
            <template #body="slotProps">
                <span v-if="!slotProps.data.archived_at" :class="'status-badge status-' + slotProps.data.task_progress?.status">{{ slotProps.data.task_progress?.name }}</span>
                <span v-else :class="'status-badge status-inprogress'">Archived</span>
            </template>
        </Column>
        <Column field="priority" header="PRIORITY" style="width: 5rem">
            <template #body="slotProps">
                <span :class="'priority-badge status-' + slotProps.data.task_priority?.toLowerCase()">{{ slotProps.data.task_priority }}</span>
            </template>
        </Column>
        <Column field="comments" header="UPDATES" style="width: 8rem">
            <template #body="slotProps">
                <Accordion v-if="slotProps.data.comments?.length">
                    <AccordionTab :header="truncateText(comment.comment, 30)" v-for="comment in slotProps.data.comments" :key="comment">
                        <span v-html="comment.comment"></span>
                    </AccordionTab>
                </Accordion>
                <div v-else>No Updates</div>
            </template>
        </Column>

        <Column field="actions" header="ACTIONS" style="width: 7rem">
            <template #body="slotProps">
                <span class="p-column-title">ACTIONS</span>
                <Button v-if="UserPermission.WRITE_TASK" icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="editTask(slotProps.data.id)" v-tooltip="`Edit ${label('Task')}`" />
                <Button icon="pi pi-eye" class="p-button-rounded p-button-info" @click="viewTaskDetails(slotProps.data.id)" v-tooltip="`View ${label('Task')}`" />
            </template>
        </Column>
    </DataTable>
</template>
<script setup>
import { computed, onUnmounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';

import { reportStore } from '../../../../../store/global-stores';
import { UserPermission } from '@/modules/permission/enum';
import { truncateText } from '@/utilities';
import { authApi } from '@/utilities/axios';
import { showToast } from '@/utilities/toast-handler';
import { useAuthStore } from '@/modules/auth/store';
import { getAllPriorities, getAllProgress } from '@/product/ams/constants';
import { useLabels } from '@/composables/LabelComposable';

const { tasks, totalTaskRecords, loading, params, taskCriteria, dynamicTask } = storeToRefs(reportStore);
const router = useRouter();
const authStore = useAuthStore();
const { label } = useLabels();

const company_id = computed(() => {
    return authStore.getLoggedUserCompanyId;
});

const loadingTaskList = ref(false)

onUnmounted(() => {
    reportStore.initparams();
});

async function onPage(event) {
    params.value = event;
    loadDynamicTaskReport()
    //await reportStore.getDynamicTaskReport();
}

function loadDynamicTaskReport() {
    const apiUrl = '/v2/report/task/dynamic'

    loadingTaskList.value = true
    let page_size = params.value.rows ?? '';
    let selectedPage = params.value.page ? params.value.page + 1 : '';
    const bodyparams = { ...taskCriteria.value, page_size: page_size, page: selectedPage, company_id: company_id.value, output: 'json' };


    const progress_status = getAllProgress();
    const priority_type = getAllPriorities();
    console.log('progress_status', progress_status)
    console.log('priority_type', priority_type)

    console.log(bodyparams, apiUrl);

    authApi.post(apiUrl, bodyparams)
        .then( (response) => {
            loadingTaskList.value = false

            if (response.statusCode === 200) {
                dynamicTask.value = response.data;
                totalTaskRecords.value = response.data?.raw.total;
                // after tasks have been loaded, load tasks details
                //await reportStore.loadTasksTableDetails();

                const allTasks = response.data.raw?.data;

                let newTasksArr = [];

                if (typeof allTasks !== 'undefined') {

                    allTasks.forEach(task => {
                        let tempTask = {
                            ...task,
                            theme_name: task.theme?.name,
                            department_to: task.department_to?.name,
                            task_progress: progress_status.find((status) => status.id == task.progress),
                            task_priority: priority_type.find((priority) => priority.id == task.priority)?.name,
                            comments: task.comments,
                        };
                        newTasksArr.push(tempTask);
                    })
                }

                tasks.value = newTasksArr
            }
        })
        .catch((error) => {
            showToast({}, error?.data?.message ?? 'Failed to dynamic task report data');
            loading.value = false;
        })

}

const editTask = (id) => {
    router.push({ name: 'TaskForm', query: { taskId: id } });
};

const rowSelected = (event) => {
    viewTaskDetails(event.data.id);
};

const viewTaskDetails = (id) => {
    router.push({ name: 'TaskDetails', params: { id } });
};
</script>
<style lang="scss">
.status-badge {
    border-radius: var(--border-radius);
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.3px;

    &.status-noprogress {
        background: #ffcdd2;
        color: #c63737;
    }
    &.status-inprogress {
        background: #feedaf;
        color: #8a5340;
    }
    &.status-completed {
        background: #c8e6c9;
        color: #256029;
    }
}

.priority-badge {
    border-radius: var(--border-radius);
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.3px;

    &.status-low {
        background: #b3e5fc;
        color: #23547b;
    }

    &.status-medium {
        background: #feedaf;
        color: #8a5340;
    }
    &.status-high {
        background: #ffcdd2;
        color: #c63737;
    }
}
</style>
